import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function NoWarranty(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "NoWarranty", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M23.597 45.6922c.2629.0772.5426.0772.8055 0 4.7864-1.361 9.1029-4.0199 12.4717-7.6823 8.7165-9.5707 7.575-22.533 6.9638-26.55-.0451-.3109-.1873-.5997-.4063-.825-.219-.2254-.5036-.3757-.8132-.4297-2.7772-.47961-5.4977-1.24338-8.1188-2.27926-3.4297-1.35609-6.663-3.16406-9.6142-5.376-.2551-.19273-.5661-.29701-.8858-.29701s-.6306.10428-.8857.29701c-2.9512 2.21194-6.1845 4.01991-9.6143 5.376-2.621 1.03563-5.34154 1.79914-8.1187 2.27846-.30956.054-.59416.2044-.81316.4297-.21901.2254-.36122.5141-.40634.8251-.60825 4.0177-1.75275 16.98 6.9637 26.55 3.3688 3.6627 7.6853 6.3218 12.4718 7.683Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24.4628 40.4205c-.2995.1058-.6261.1058-.9255 0-3.4755-1.1984-6.6015-3.2362-9.1005-5.9325-5.7323-6.2512-6.3833-14.4382-6.1463-19.3567.01291-.3353.13346-.6575.34378-.9189.21033-.2613.49925-.448.82397-.5324 1.93115-.4798 3.82895-1.085 5.68125-1.812 2.8228-1.1079 5.5287-2.49294 8.0783-4.13474.2323-.1526.5042-.2339.7822-.2339s.5499.0813.7822.2339c2.5499 1.6419 5.2561 3.02714 8.079 4.13554 1.8522.7263 3.7498 1.3313 5.6806 1.8112.3247.0844.6136.2711.8239.5324.2103.2614.3309.5836.3438.9189.237 4.9185-.414 13.1055-6.1462 19.3567-2.4991 2.6963-5.6251 4.7341-9.1005 5.9325Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m24.5303 27 3.9922 3.9923c.3272.327.7708.5107 1.2334.5107s.9062-.1837 1.2334-.5107c.327-.3272.5108-.7708.5108-1.2334s-.1838-.9063-.5108-1.2334L27 24.5303c-.1406-.1407-.2196-.3314-.2196-.5303 0-.1989.079-.3896.2196-.5303l3.9923-3.9922c.327-.3271.5108-.7708.5108-1.2334s-.1838-.9062-.5108-1.2334c-.3272-.327-.7708-.5107-1.2334-.5107s-.9062.1837-1.2334.5107L24.5303 21c-.1407.1406-.3314.2196-.5303.2196-.1988 0-.3896-.079-.5302-.2196l-3.9923-3.9893c-.3271-.327-.7708-.5107-1.2333-.5107-.4626 0-.9063.1837-1.2334.5107-.3271.3272-.5108.7708-.5108 1.2334s.1837.9063.5108 1.2334L21 23.4697c.1406.1407.2196.3314.2196.5303 0 .1989-.079.3896-.2196.5303l-3.9892 3.9922c-.3271.3271-.5108.7708-.5108 1.2334s.1837.9062.5108 1.2334c.3271.327.7708.5107 1.2334.5107.4625 0 .9062-.1837 1.2333-.5107L23.4698 27c.1406-.1406.3314-.2196.5302-.2196.1989 0 .3896.079.5303.2196Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
NoWarranty.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "NoWarranty"
};
validateTidalLicense();
export {
  NoWarranty
};
//# sourceMappingURL=NoWarranty.js.map
